<template>
  <div class="mod-dial" @click="$emit('close')">
    <div class="mod-cont" @click.stop>
      <span class="close-main" @click="$emit('close')">
        <i class="bi bi-x-lg"></i>
      </span>
      <div class="mod-body">
        <div class="mod-reports">
          <h3 class="tab-title">{{ $t('REPORTS_MANAGE') }}</h3>
          
          <!-- Alerts container -->
          <div ref="alertContainer" class="alerts-container"></div>
          
          <!-- Current Auto Reports List -->
          <div v-if="getAutoReports && getAutoReports.length > 0" class="current-reports">
            <h4>{{ $t('REPORTS_CURRENT_AUTO_REPORTS') }}:</h4>
            <div class="auto-reports-table">
              <div class="reports-header">
                <div>{{ $t('REPORTS_TABLE_PAGES') }}</div>
                <div>{{ $t('REPORTS_TABLE_EMAILS') }}</div>
                <div>{{ $t('REPORTS_TABLE_PERIOD') }}</div>
                <div>{{ $t('REPORTS_TABLE_FORMAT') }}</div>
                <div>{{ $t('REPORTS_TABLE_ACTION') }}</div>
              </div>
              <div class="reports-row" v-for="report in getAutoReports" :key="report.id">
                <div>{{ report.names }}</div>
                <div>{{ report.emails }}</div>
                <div>{{ report.period }}</div>
                <div>{{ report.type.toUpperCase() }}</div>
                <div>
                  <span class="delete-report" @click="deleteAutoReport(report.id)">
                    <i class="bi bi-x-lg"></i>
                  </span>
                </div>
              </div>
            </div>
            
          </div>
          <div v-else class="no-auto-reports">
            <p>{{ $t('REPORTS_NO_AUTO_REPORTS_YET') }}</p>
          </div>

          <!-- Auto Reports Limit Alert -->
          <div v-if="isLimitReached" class="alert limit-alert">
            <i class="bi bi-exclamation-triangle"></i>
            {{ $t('AUTOREPORTS_LIMIT_REACHED', { limit: autoReportsLimit }) }}
          </div>

          <!-- Create New Auto Report -->
          <h4>{{ $t('REPORTS_CREATE_NEW_AUTO_REPORT') }}:</h4>
          <div class="mod-soc-pres">
            <div class="sel-pages">
              <div class="labels-block">
                <div class="sel-pg" :key="index" v-for="(page, index) in pages">
                  <img :src="page.owner_avatar" alt />
                  <div>
                    <p>{{ page.owner_name }}</p>
                    <span v-if="page.social == 'FB'">Facebook</span>
                    <span v-if="page.social == 'IG'">Instagram</span>
                    <span v-if="page.social == 'VK'">VK</span>
                  </div>
                  <span class="close" @click="unselectPage(page.hash_id)"><i class="bi bi-x-lg"></i></span>
                </div>
              </div>
              
            </div>
          </div>
          <div class="mod-inner">
            <div class="b16">{{ $t('REPORTS_TO') }}:</div>
            <div class="sel-pages emails-list">
              <div
                class="sel-pg"
                :key="index"
                v-for="(email, index) in emails"
              >
                <span class="indicator default-back"></span>
                <div>
                  <p>{{ email }}</p>
                </div>
                <span class="close" @click="deleteEmail(email)"><i class="bi bi-x-lg"></i></span>
              </div>
            </div>

            <form @submit.prevent="addEmail" class="inp-btn">
              <input
                type="text"
                class="inp-st"
                placeholder="Email"
                v-model="email"
              />
              <button class="btn-st-red" type="submit">
                {{ $t('ADD_PAGE_SELECT_PAGE') }}
              </button>
            </form>
            <div class="b16">{{ $t('REPORTS_REG') }}</div>
            <form action class="inp-rad">
              <input
                type="radio"
                name="radio"
                id="x1"
                @click="period = 'week'"
                :checked="period == 'week' ? true : false"
              />
              <label for="x1">{{ $t('REPORTS_REG_WK') }}</label>
              <input
                type="radio"
                name="radio"
                id="x2"
                @click="period = 'month'"
                :checked="period == 'month' ? true : false"
              />
              <label for="x2">{{ $t('REPORTS_REG_MN') }}</label>
            </form>
            <div class="b16">{{ $t('REPORTS_FORM') }}</div>
            <form action class="inp-rad">
              <input
                type="radio"
                name="format"
                id="format1"
                @click="type = 'pptx'"
                :checked="type == 'pptx' ? true : false"
              />
              <label for="format1" class="inp-rad">PPTX</label>
              <input
                type="radio"
                name="format"
                id="format2"
                @click="type = 'pdf'"
                :checked="type == 'pdf' ? true : false"
              />
              <label for="format2" class="inp-rad">PDF</label>
              <input
                type="radio"
                name="format"
                id="format3"
                @click="type = 'xlsx'"
                :checked="type == 'xlsx' ? true : false"
              />
              <label for="format3" class="inp-rad">XLSX</label>
            </form>
          </div>
          <button 
            class="btn-st-viol btn-st-bg btn-st-green" 
            type="button" 
            @click="makeAutoReport"
            :disabled="isLimitReached"
            :class="{ 'disabled': isLimitReached }"
          >
            {{ $t('REPORTS_SAVE') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { INTRO_SET_AUTOREPORTS_SETTINGS_VISIBLE } from "../../store/actions/intro";
import { AUTOREPORTS_GET, DELETE_AUTOREPORT } from "../../store/actions/reports";
import module from '@/models/AxiosModule'

export default {
  name: "AutoReportSettings",
  computed: {
    ...mapGetters([
      "getProfile",
      "getHash",
      "getPages",
      "getSelectedPages",
      "getAutoReports",
    ]),
    autoReportsLimit() {
      // Auto reports limit = page limit from the plan
      return this.getProfile.pageLimit || 5;
    },
    isLimitReached() {
      // Check if current auto reports count has reached the limit
      const currentCount = this.getAutoReports ? this.getAutoReports.length : 0;
      return currentCount >= this.autoReportsLimit;
    }
  },

  data() {
    return {
      period: "week",
      type: "pdf",
      title: "",
      emails: [],
      email: undefined,
      pages: [],
      currentAlertMessage: null,
      alertTimeoutId: null,
    };
  },
  mounted() {
    this.emails = [this.getProfile.email];
    this.pages = JSON.parse(JSON.stringify(this.getSelectedPages));
    // Load auto reports when modal opens
    this.AUTOREPORTS_GET();
  },
  methods: {
    ...mapMutations([INTRO_SET_AUTOREPORTS_SETTINGS_VISIBLE]),
    ...mapActions([AUTOREPORTS_GET, DELETE_AUTOREPORT]),
    makeAutoReport: function () {
      // Check limit before creating
      if (this.isLimitReached) {
        this.showInlineAlert(this.$t('AUTOREPORTS_LIMIT_REACHED', { limit: this.autoReportsLimit }), 'red');
        return;
      }

      const hash_ids = this.pages.map((page) => page.hash_id).join(",");
      const names = this.pages.map((page) => page.owner_name);
      const axios = module.Axios;

      axios
        .post("create-auto-report", {
          hash_ids,
          period: this.period,
          type: this.type,
          emails: this.emails,
          names,
        })
        .then((res) => {
          // Refresh the auto reports list after creating new one
          this.AUTOREPORTS_GET();
          // Show success message
          this.showInlineAlert(this.$t('AUTOREPORTS_CREATE_SUCCESS'), 'green');
        })
        .catch((error) => {
          // Show error message
          if (error?.response && error?.response?.data) {
            if (error.response.data?.error_code) {
              this.showInlineAlert(this.$t(error.response.data?.error_code), 'red');
            } else {
              this.showInlineAlert(this.$t("AUTOREPORTS_CREATE_ERROR"), 'red');
            }
          } else {
            this.showInlineAlert(this.$t("AUTOREPORTS_CREATE_ERROR"), 'red');
          }
        });
    },
    deleteAutoReport: function(reportId) {
      this.DELETE_AUTOREPORT({ id: reportId }).then(() => {
        // Refresh the list after deletion
        this.AUTOREPORTS_GET();
        // Show success message
        this.showInlineAlert(this.$t('AUTOREPORTS_DELETE_SUCCESS'), 'green');
      }).catch((error) => {
        // Show error message
        this.showInlineAlert(this.$t('AUTOREPORTS_DELETE_ERROR'), 'red');
      });
    },
    addEmail() {
      if (!this.email.length) return;
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.email = String(this.email).toLowerCase();
      if (!re.test(this.email) || this.emails.includes(this.email)) return;
      this.emails.push(this.email);
    },
    deleteEmail(email) {
      if (this.emails.length == 1) return;
      this.emails = this.emails.filter((em) => em != email);
    },
    unselectPage(hash) {
      if (this.pages.length == 1) return;
      this.pages = this.pages.filter((p) => p.hash_id != hash);
    },
    showInlineAlert(message, color = "") {
      // If there's already an alert with this message, don't show another one
      if (this.currentAlertMessage === message && this.alertTimeoutId) {
        // Clear the existing timeout to reset it
        clearTimeout(this.alertTimeoutId);
        // Set a new timeout
        this.alertTimeoutId = setTimeout(() => {
          this.currentAlertMessage = null;
          this.alertTimeoutId = null;
        }, 5000);
        return;
      }
      
      // Store the current alert message
      this.currentAlertMessage = message;
      
      // Show the alert
      this.$alert.show({
        message: message,
        type: "inline",
        color: color,
        component: this,
        target: this.$refs.alertContainer,
      });
      
      // Set a timeout to clear the current alert tracking
      this.alertTimeoutId = setTimeout(() => {
        this.currentAlertMessage = null;
        this.alertTimeoutId = null;
      }, 5000);
    },
  },
};
</script>
